import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";

// Components
import UserRoute            from "dashboard/dist/Components/UserRoute";



/**
 * Only Authenticated Students can access the given Component
 */
class StudentRoute extends React.Component {
    /**
     * Do the Render
     * @returns {Object}
     */
    render() {
        const { isAuthenticated, isStudent, ...rest } = this.props;

        return <UserRoute
            {...rest}
            isAuthenticated={isAuthenticated}
            isValid={isStudent}
        />;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        isAuthenticated : PropTypes.bool.isRequired,
        isStudent       : PropTypes.bool.isRequired,
        isHidden        : PropTypes.bool,
        url             : PropTypes.string.isRequired,
        component       : PropTypes.oneOfType([ PropTypes.func, PropTypes.object ]).isRequired,
        exact           : PropTypes.bool,
        type            : PropTypes.string,
        path            : PropTypes.string,
        location        : PropTypes.object,
        match           : PropTypes.object,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            isAuthenticated : state.auth.isAuthenticated,
            isStudent       : state.auth.isStudent,
        };
    }
}

export default connect(StudentRoute.mapStateToProps)(StudentRoute);
